// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd54b6f4","667":"cc0a20aa"}[chunkId] + ".chunk.js";
};